import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  search: function (request) {
    return axios.get('/api/analytics/poll/report', { params: request })
  },
  exportFile: function(request) {
    return Utils.downloadFile('/api/analytics/poll/exportreport', "ReportPoll.xlsx", request)
  }
}